export const BASE_MIN = 0; // Mininum value for base offering

export const BASE_MAX = 1200000000; // 1.2 Billion - maximum value for base offering

export const ADVANCED_MIN = 0; // Mininum value for advanced offering

export const ADVANCED_MAX = 2400000000; // 2.4 Billion - maximum value advanced offering

export const BASE_DEFAULT = 100000; // 100K - default value for advanced offering

export const ADVANCED_DEFAULT = 1200000; // 1.2 Million - default value for advanced offering

export const BASE_UNIT_100K = 100000; // 100K is equivalent to 1 UNIT base offering

export const ADVANCED_UNIT_1M = 1000000; // 1M is equivalent to 1 UNIT advanced offering

// Tiers for Advanced Offering
export const ADVANCED_TIER_100M = 100 * ADVANCED_UNIT_1M;
export const ADVANCED_TIER_250M = 250 * ADVANCED_UNIT_1M;
export const ADVANCED_TIER_500M = 500 * ADVANCED_UNIT_1M;
export const ADVANCED_TIER_750M = 750 * ADVANCED_UNIT_1M;
export const ADVANCED_TIER_1200M = 1200 * ADVANCED_UNIT_1M;
export const ADVANCED_TIER_2400M = 2400 * ADVANCED_UNIT_1M;

//Part Numbers
export const BASE_PN = 'D09ZVZX';
export const ADVANCED_PN = 'D0DQJZX';
